import API from '../api'
import deleteUrl from './paths'

export const deleteContentApi = (contentId) =>
	new Promise((resolve, reject) => {
		API.delete(deleteUrl.deleteContent, { contentId })
			.then((response) => {
				resolve(response.data)
			})
			.catch((err) => reject(err))
	})
